module.exports = __webpack_public_path__ + "media/components/PageBuilder/interface/images/logo-48decb9dd32e414d4cdcfb6ab82f07a8.png";